import React from "react";
import { useNavigate } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { Panel, GhostBtn, STATUS_TONE, statusBar } from "./ui";

export function TodayServices({ items }) {
  const nav = useNavigate();
  return (
    <Panel title="Servizi di oggi" testid="nx-today" right={<GhostBtn onClick={() => nav("/prenotazioni")} testid="nx-today-agenda">Vedi agenda</GhostBtn>} bodyClass="px-2 pb-2">
      <div className="max-h-[300px] overflow-y-auto divide-y divide-white/5">
        {items.map(s => {
          const un = !s.driver_name && !s.external && ["Confermata", "Assegnata"].includes(s.status);
          return (
            <button key={s.id} type="button" onClick={() => nav(`/prenotazioni?open=${s.id}`)} data-testid={`nx-today-${s.id}`} className="w-full flex items-center gap-3 px-2 py-2.5 text-left hover:bg-white/[0.03]">
              <span className={`w-[3px] self-stretch rounded-full ${statusBar(s.status, un)}`} />
              <span className="font-mono-num text-[14px] text-white w-12 shrink-0">{s.time || "--:--"}</span>
              <span className="min-w-0 flex-1"><span className="block text-[13px] text-white truncate">{s.customer_name}</span><span className="block text-[11px] text-slate-400 truncate">{s.pickup} → {s.destination}</span></span>
              <span className={`px-2 py-0.5 rounded-md border text-[10.5px] font-semibold whitespace-nowrap ${un ? "bg-amber-500/90 text-black border-amber-400" : STATUS_TONE[s.status] || "bg-white/5 text-slate-300 border-white/10"}`}>{un ? "Da assegnare" : s.status}</span>
              <MoreHorizontal size={15} className="text-slate-500 shrink-0" />
            </button>
          );
        })}
        {!items.length && <div className="text-sm text-slate-500 text-center py-10" data-testid="nx-today-empty">Nessun servizio programmato per oggi</div>}
      </div>
    </Panel>
  );
}
